import { Link } from 'react-router-dom';
import { categories } from '@/mocks/mangaData';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-2">
            探索分类
          </h2>
          <p className="text-sm text-foreground-500">按题材找到你喜欢的韩国漫画</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl flex items-center justify-center bg-primary-100 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${cat.icon} text-2xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <div className="text-center">
                <h3 className="text-sm md:text-base font-bold font-heading text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-400 mt-1">点击浏览</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}